import { createStore } from 'redux';

class Subscribe {

    // 如果有其他方法处理需要写入方法名 例如SetArr 把变化的值更新给state
    reducer = (state = {}, actions) => {
        const { type, payload } = actions;
        switch (type) {
            case "SetArr":
                return Object.assign({}, state, {
                    arr: payload
                })
                break;
            case "SetZhuguanNum":
                return Object.assign({}, state, {
                    zhuguanNum:payload,
                })
                break;
            default:
                return state;
                break;
        }
    }

    // 默认当前初始值
    initStore = {
        arr: [],
        zhuguanNum:""
    }

    // 上一次的值， 此时默认初始值
    preStore = {
        arr: [],
        zhuguanNum:""
    }

    store = createStore(this.reducer, this.initStore);

    // 监听数据变化
    on = (fn) => {
        const listener = () => {
            fn && fn(this.store.getState(), this.preStore);
        }
        
        this.store.subscribe(listener);
    }

    // 获取上一次的state即仓库的所有存储值
    preGetState = () => {
        const store = this.store.getState();
        this.preStore = store;
    }

    // 获取当前的state即仓库的所有存储值
    getState = () => {
        return this.store.getState();
    }

    // 触发内容更新的公共方法
    dispatch = (actions) => {
        // 更新当前值之前记录上一次的值
        this.preGetState();
        // 更新仓库的值
        this.store.dispatch(actions);
    }

    // 设置arr， type与reducer 的type保持一致， payload为修改的值，调用dispatch会更新仓库state
    setArr = (payload) => {
        this.dispatch({
            type: 'SetArr',
            payload,
        })
    }
    setZhuguanNum = (payload) => {
        this.dispatch({
            type: 'SetZhuguanNum',
            payload,
        })
    }
}

// 初始化方法
const globalSubscribe = new Subscribe();

export default globalSubscribe;